export default "__VITE_ASSET__DjlTQBFD__"